const runs = new Map<string, AbortController>();

export const beginRun = (key: string) => {
  runs.get(key)?.abort();
  const c = new AbortController();
  runs.set(key, c);
  return c;
};

export const abortRun = (key: string) => {
  runs.get(key)?.abort();
  runs.delete(key);
};

export const endRun = (key: string, c: AbortController) => {
  if (runs.get(key) === c) runs.delete(key);
};